// removed by extract-text-webpack-plugin
module.exports = {"container":"Hf29RkVxYyWdB4HCoMYJQ","row":"_1T6bDAbrvbw63KPQtenxcr","table":"_2qi2iXiXj3CDtM9bE_PRp1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisSellOrders.scss
// module id = 1205
// module chunks = 0